import React, { Fragment } from "react";

import { Form, Col, Row, Card } from "react-bootstrap";
import { DECLARATION_PLACES } from "../../../../../constants/constants";
import { getFormattedDate, getFullName } from "../../../../../util/helpers";
import useValidation from "../../../../../util/useValidation";

const Declaration = ({ personalDetails, updatePersonalDetails }) => {
  const { handleOnBlurValidation, errors } = useValidation();

  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };

  const handleOnChangePersonalDetails = ({ target: { name, value } }) => {
    updatePersonalDetails(name, value);
  };

  return (
    <Card className="mt-2">
      <Card.Header>Declaration by Applicant</Card.Header>
      <Card.Body>
        I confirm that the information provided by me in this application is
        accurate and correct. I understand that in the event, any of the
        information provided by me is found to be wrong, it could result in
        termination of my employment without any notice.
        <Row>
          {personalDetails.cDKEmployeeType === 2 ||
          personalDetails.cDKEmployeeType === 3 ? (
            <Fragment>
              <Col sm={4}>
                <Form.Label>Place*</Form.Label>
                <Form.Control
                  size="sm"
                  required
                  as="select"
                  name="declarationPlace"
                  value={personalDetails.declarationPlace}
                  onChange={handleOnChangePersonalDetails}
                  onBlur={handleOnBlurInput}
                  isInvalid={errors.declarationPlace}
                >
                  <option value="">Choose...</option>
                  {DECLARATION_PLACES.map(place => (
                    <option value={place.id}>{place.name}</option>
                  ))}
                </Form.Control>
                {errors.declarationPlace && (
                  <Form.Control.Feedback type="invalid">
                    {errors.declarationPlace.type === "required" &&
                      "Place is required"}
                  </Form.Control.Feedback>
                )}
              </Col>
              <Col sm={4} />
            </Fragment>
          ) : (
            <Col sm={8} />
          )}
          <Col sm={4}>
            <Form.Label>Signature*</Form.Label>
            <Form.Control
              disabled
              size="sm"
              required
              type="text"
              name="signature"
              value={personalDetails.firstName + " " + personalDetails.lastName}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Form.Label>Date*</Form.Label>
            <Form.Control
              size="sm"
              required
              disabled
              type="date"
              name="date"
              value={getFormattedDate(
                personalDetails.declarationDate,
                undefined,
                "YYYY-MM-DD"
              )}
            />
          </Col>
          <Col sm={4}></Col>
          <Col sm={4}>
            <Form.Label>Name*</Form.Label>
            <Form.Control
              disabled
              size="sm"
              required
              type="text"
              name="name"
              value={getFullName(personalDetails)}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Declaration;
